import React, { useCallback, useRef } from 'react';

import { Box } from '@mui/material';
import { Form } from '@formio/react';

import { useScrollTools } from 'hooks/FormIO';
import useMutationObserver from 'hooks/useMutationObserver';
import {
  fixCheckboxSelectionBug,
  fixRadioSelectionBug,
} from 'formio/framework/templates/utils';

const CoreQuestionnaireFormIO = ({
  form,
  onCancel,
  onSubmit,
  onSave,
  handleTaskEntryChange,
  defaultValues,
  readOnly = true,
  page = 0,
}) => {
  const rootRef = useRef(null);
  const saveData = useRef({});
  const currentPage = useRef(page);

  const { scrollToTop, restoreScrollPosition } = useScrollTools();

  const setupExtraActions = ({ onCancel } = {}) => {
    if (onCancel) {
      const cancelBtn =
        rootRef?.current?.getElementsByClassName?.('btn-wizard-cancel')?.[0];
      cancelBtn?.addEventListener?.('click', onCancel);
    }
    const nextBtn =
      rootRef?.current?.getElementsByClassName?.('btn-wizard-forward')?.[0];
    nextBtn?.addEventListener?.('click', () => {
      const errorQuestion =
        rootRef?.current?.getElementsByClassName?.('form-text error')?.[0]
          ?.parentElement?.parentElement;
      errorQuestion?.scrollIntoView();
    });

    const submitBtn =
      rootRef?.current?.getElementsByClassName?.('btn-wizard-submit')?.[0];
    submitBtn?.addEventListener?.('click', () => {
      const alertPopup =
        rootRef?.current?.getElementsByClassName?.('alert-success')?.[0];
      if (alertPopup) {
        alertPopup.style.display = 'none';
      }
    });

    const saveBtn =
      rootRef?.current?.getElementsByClassName?.('btn-wizard-save')?.[0];
    if (readOnly) {
      saveBtn.style.display = 'none';
      return;
    }
    saveBtn?.addEventListener?.('click', () => {
      onSave({
        data : saveData.current,
        page : currentPage.current,
      });
    });
  };
  const setup = useCallback(() => setupExtraActions({ onCancel }), [onCancel]);
  useMutationObserver(rootRef, setup);

  const handleNavPage = ({ submission: { data } }) => {
    fixRadioSelectionBug(data, rootRef);
    fixCheckboxSelectionBug(data, rootRef);
    scrollToTop();
  };

  const handleChange = ({ data }) => {
    fixRadioSelectionBug(data, rootRef);
    fixCheckboxSelectionBug(data, rootRef);
    restoreScrollPosition();
    handleTaskEntryChange?.(data);
  };

  const handleFormReady = (e) => {
    e.root.setPage(currentPage.current);
    setupExtraActions({ onCancel });
    fixRadioSelectionBug(defaultValues, rootRef);
    fixCheckboxSelectionBug(defaultValues, rootRef);
  };

  return (
    <Box
      ref={rootRef}>
      <Form
        submission={defaultValues && { data: defaultValues }}
        formReady={handleFormReady}
        onNextPage={(e) => {
          currentPage.current = e.page;
          handleNavPage(e);
        }}
        onPrevPage={(e) => {
          currentPage.current = e.page;
          handleNavPage(e);
        }}
        onSubmit={onSubmit}
        form={form}
        options={{ template: 'coreQuestionnaire', readOnly }}
        onChange={handleChange}
      />
    </Box>
  );
};

export default CoreQuestionnaireFormIO;
